import BaseView from './BaseView';
import ReviewSlider from '../../components/ReviewSlider';
import VideoPlayer from '../../components/VideoPlayer';
import TeamMembers from '../../components/TeamMembers';
import KletskaartjesCarousel from '../../components/KletskaartjesCarousel';
import { gsap } from 'gsap';

let view = null;

class TemplateLandingpage extends BaseView {
	constructor(container) {
		super(container);

		this.container = container;
		this.heroButtons = this.container.querySelectorAll('[data-hero-button]');

		this.heroButtons.forEach((button) => {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				const target = button.getAttribute('href');
				const targetElement = document.querySelector(target);
				if (targetElement) {
					const targetOffset = targetElement.getBoundingClientRect().top + window.scrollY;
					gsap.to(window, {
						duration: 1,
						scrollTo: { y: targetOffset },
						ease: 'power3.inOut',
					});
				}
			});
		});
	}

	init() {
		this.container.querySelectorAll('[data-slider-review]').forEach((el) => new ReviewSlider(el));
		this.container.querySelectorAll('[data-video-player]').forEach((el) => new VideoPlayer(el));
		this.container.querySelectorAll('[data-team-members]').forEach((el) => new TeamMembers(el));
		this.container.querySelectorAll('[data-kletskaartjes-carousel]').forEach((el) => new KletskaartjesCarousel(el));
	}

	destroy() {
		this.heroButtons.forEach((button) => {
			button.removeEventListener('click', this.handleButtonClick);
		});
	}
}

export default {
	namespace: 'template-landingpage',
	beforeEnter: ({ current, next, trigger }) => {
		view = new TemplateLandingpage(next.container);
		view.init();
	},
	afterLeave: ({ current, next, trigger }) => {
		view.destroy();
		view = null;
	},
};
